export default __webpack_public_path__ + "static/media/arrow-side.98cc53bd.svg";